import MCQuestion from "./MCQuestion";
import SliderQuestion from "./SliderQuestion";
import "../styles/styles.css";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";

function Quiz(props) {
  const [numAnswered, setNumAnswered] = useState(0);
  const [numCorrect, setNumCorrect] = useState(0);
  const [data, setData] = useState(null);

  const JSONpath = process.env.PUBLIC_URL + "/data/" + props.for + ".json";
  useEffect(() => {
    fetch(JSONpath)
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((_) => console.log(_));
  }, [JSONpath]);

  const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const imagePath = isDarkMode ? "/images/logo-white.png" : "/images/logo-black.png";

  if (data === null) {
    return (
      <div className="Main Load">
        <a href="https://www.browndailyherald.com/">
          <img
            id="logo"
            src={process.env.PUBLIC_URL + imagePath}
            alt="logo"
          />
        </a>
        <CircularProgress style={{ marginTop: "5%" }} color="inherit" />
      </div>
    );
  }

  const numQuestions = data["questions"].length;

  return (
    <div className="Main">
      <a href="https://www.browndailyherald.com/" target="_">
        <img
          id="logo"
          src={process.env.PUBLIC_URL + imagePath}
          alt="logo"
        />
      </a>

      <h4 id="intro">{data.intro}</h4>
      <p id="date">{data.date}</p>
      <p id="me">Web Design: Kiera Walsh and Caleb Ellenberg</p>

      {data.questions.map((data, i) => {
        data["number"] = i + 1;
        data["setNumAnswered"] = setNumAnswered;
        data["setNumCorrect"] = setNumCorrect;
        data["imgPath"] = process.env.PUBLIC_URL + "/images/" + props.for + "/";
        if (data.type === "MC") {
          data["answer_i"] = data["answer"].toLowerCase().charCodeAt(0) - 97; // A -> 0, B -> 1 ...
          return <MCQuestion {...data} key={`Q${data.number}`} />;
        } else {
          return <SliderQuestion {...data} key={`Q${data.number}`} />;
        }
      })}
      {numAnswered === numQuestions && (
        <div>
          <h4 className="score">
            You got {numCorrect} out of {numQuestions} questions correct!
            {numCorrect / numAnswered >= 0.7 && <h4>Great job {":)"}</h4>}
          </h4>
        </div>
      )}
    </div>
  );
}

export default Quiz;
